import { useRef } from 'react';

export default function useThrowPromiseIfNull<T>(
  item: T | null | undefined,
): NonNullable<T> {
  const ref = useRef<{
    timeout?: NodeJS.Timeout;
    resolve?: (value: boolean) => void;
  }>({});
  if (item === null || item === undefined) {
    throw new Promise<boolean>((resolve) => {
      if (ref.current.timeout && ref.current.resolve) {
        clearTimeout(ref.current.timeout);
        delete ref.current.timeout;
        ref.current.resolve(true);
      }
      ref.current.resolve = resolve;
      ref.current.timeout = setTimeout(() => {
        resolve(true);
        ref.current = {};
      }, 1000);
    });
  } else if (ref.current.timeout && ref.current.resolve) {
    clearTimeout(ref.current.timeout);
    delete ref.current.timeout;
    ref.current.resolve(true);
    ref.current = {};
  }
  return item as NonNullable<T>;
}
